import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, createVNode as _createVNode } from "vue"

const _hoisted_1 = ["rowspan"]
const _hoisted_2 = { class: "d-flex flex-column justify-space-between text-break" }
const _hoisted_3 = { class: "mt-1 flex-grow-1 flex-wrap d-flex" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Acceptability = _resolveComponent("Acceptability")!
  const _component_ItemsCount = _resolveComponent("ItemsCount")!

  return (_openBlock(), _createElementBlock("td", {
    class: "criterion",
    rowspan: _ctx.getAimsBy('criterion', _ctx.criterionId).length
  }, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", null, _toDisplayString(_ctx.c_criterions[_ctx.aim.criterion].name), 1),
      _createElementVNode("div", _hoisted_3, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.c_alternativesIds, (alternativeId, index) => {
          return (_openBlock(), _createBlock(_component_Acceptability, {
            key: `criterion-alternative-${index}-${_ctx.criterionItems[alternativeId]}`,
            class: "mb-1 mr-1",
            icon: true,
            alternative: alternativeId,
            items: _ctx.criterionItems[alternativeId]
          }, null, 8, ["alternative", "items"]))
        }), 128))
      ])
    ]),
    _createVNode(_component_ItemsCount, { count: _ctx.totalItems }, null, 8, ["count"])
  ], 8, _hoisted_1))
}